<template>
  <span>
    <div>
      <v-row>
        <v-col>
          <p class="title-1" v-bind:style="{'font-size':fontSize}">
            {{data.title}}
          </p>
        </v-col>

        <img v-if="data.visible"
        @click="data.visible = !data.visible"
          src="../../assets/pinjaman/minus-circle.png"
          srcset="
            ../../assets/pinjaman/minus-circle@2x.png 2x,
            ../../assets/pinjaman/minus-circle@3x.png 3x
          "
          class="minus-circle"
        />
         <img v-else
         @click="data.visible = !data.visible"
          src="../../assets/pinjaman/plus-circle.png"
          srcset="
            ../../assets/pinjaman/plus-circle@2x.png 2x,
            ../../assets/pinjaman/plus-circle@3x.png 3x
          "
          class="plus-circle"
        />
      </v-row>

      <p class="Desc" v-if="data.visible" >
        {{data.detail}}
      </p>
      <p class="Fade-Out" v-if="!data.visible">
        
      </p>
    </div>

    <v-divider />
  </span>
</template>

<script>
export default {
  props: ["data"],

 
};
</script>

<style scoped>

.Question {
  height: 361px;
  flex-grow: 0;
  margin: 50px 0 0;
  padding: 20px 0 0;
}
.title-1 {


  flex-grow: 0;

  margin: 0 13px 8px 0;

  font-family: Inter;

  font-size: 14px;

  font-weight: 600;

  font-stretch: normal;

  font-style: normal;

  line-height: 1.43;

  letter-spacing: normal;

  text-align: left;

  color: #252525;
}
.Desc {
  /* width: 312px; */
  /* height: 76px; */
  flex-grow: 0;
  margin: 8px 13px 0 0;
  font-family: Inter;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.46;
  letter-spacing: normal;
  text-align: left;
  color: #252525;animation: fadein 1s;
}
.minus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 13px 56px;
  object-fit: contain;
}
.plus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 20px 56px;
  object-fit: contain;
  display: inline;
}
.Fade-Out{
  animation: fadeout 1s;
}

@keyframes fadein {
    0% { opacity: 0; height:0px; }
    20%   { opacity: 0.6; height:50px}
    100% { opacity: 1; height:76px;}
}

@keyframes fadeout {
    0% { opacity: 0; height:76px; }
    20%   { opacity: 0.6; height:20px}
    100% { opacity: 1; height:0px}
}
</style>
